import { render } from "./bottom-menu.vue?vue&type=template&id=5ef09e3f"
import script from "./bottom-menu.vue?vue&type=script&lang=js"
export * from "./bottom-menu.vue?vue&type=script&lang=js"

import "./bottom-menu.vue?vue&type=style&index=0&id=5ef09e3f&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__